export default __webpack_public_path__ + "static/media/result--new.d8629794.svg";